/**
 * Reusable stateless form component for Evaluation
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import { EditorState, convertToRaw } from 'draft-js';

import VideoTrackListItem from '../../scene/components/VideoTrackListItem.js.jsx'

// import form components
import {
  CdnPathInput
  , CheckboxInput
  , NumberInput
  , RichEditor
  , SelectFromArray
  , TextAreaInput
  , TextInput
} from '../../../global/components/forms';

function EvaluationForm({
  addTrack
  , cancelLink
  , deleteTrack
  , evaluation
  , formHelpers
  , formTitle
  , formType
  , handleTrackFormChange
  , handleFormChange
  , handleFormSubmit
  , contentModule
}) {
  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="evaluationForm" className="evaluation-form" onSubmit={handleFormSubmit}>
            <div className="formHeader">
              <h2> Update General Information </h2>
              <em>This is an evaluation for <Link to={`/admin/authoring/content-modules/${contentModule._id}`} target="_blank">{contentModule.title}</Link></em>
              <hr/>
            </div>
            <div className="-form-step"><span className="-num">1</span> Title & Introduction Content</div>
            <div className="yt-col full m_60">
              <TextAreaInput
                change={handleFormChange}
                label="Evaluation Title"
                helpText={<span>{evaluation.title ? evaluation.title.length : 0} of 150</span>}
                name="evaluation.title"
                rows="1"
                maxLength="150"
                required={true}
                value={evaluation.title}
                />
            </div>
            <div className="yt-col full m_60">
              <CdnPathInput
                change={handleFormChange}
                label="Intro Video Path"
                name="evaluation.introVidPath"
                required={false}
                validate={false}
                value={evaluation.introVidPath}
              />
              <CdnPathInput
                change={handleFormChange}
                label="Intro Poster Path"
                name="evaluation.introPosterPath"
                required={false}
                validate={false}
                value={evaluation.introPosterPath}
              />
            </div>
            <div className="input-group">
              <label>Intro Subtitle Tracks</label>
              <div className="-subtitle-tracks">
                {evaluation.introTracks ? evaluation.introTracks.map((track, i) =>
                  <VideoTrackListItem
                    deleteTrack={deleteTrack}
                    handleTrackFormChange={handleTrackFormChange}
                    index={i}
                    key={i}
                    track={track}
                    formType='intro'
                  />
                )
                :
                  null
                }
              </div>
              <button type="button" className="yt-btn x-small link success" onClick={() => addTrack('intro')} style={{marginRight:20}}>+ Add track file</button>
            </div>
            <RichEditor
              change={handleFormChange}
              helpText="This appears at the begining of the evaluation."
              isNewContent={formHelpers.isNewIntroContent}
              label="Introduction content"
              name="evaluation.introContent"
              required={false}
              value={evaluation.introContent && evaluation.introContent.blocks && evaluation.introContent.blocks.length > 0 ? evaluation.introContent : convertToRaw(EditorState.createEmpty().getCurrentContent())}
            />

            {/* NOTE: not allowing this for now
              <div className="yt-col full m_50">
                <CheckboxInput
                  change={handleFormChange}
                  checked={evaluation.randomizeQuestionOrder}
                  helpText={<span>Questions will appear in a new random order on every page load.<br/><strong>NOTE: </strong> This overrides order assigned to each question.</span>}
                  label="Force randomized question order?"
                  name="evaluation.randomizeQuestionOrder"
                  value={evaluation.randomizeQuestionOrder}
                />
              </div>
            */}
            <div className="-form-step"><span className="-num">2</span> Post Evaluation Content </div>
            <div className="yt-col full m_60">
              <CdnPathInput
                change={handleFormChange}
                label="Post Evaluation Video Path"
                name="evaluation.postEvalVidPath"
                required={false}
                validate={false}
                value={evaluation.postEvalVidPath}
              />
              <CdnPathInput
                change={handleFormChange}
                label="Post Evaluation Poster Path"
                name="evaluation.postEvalPosterPath"
                required={false}
                validate={false}
                value={evaluation.postEvalPosterPath}
              />
            </div>
            <div className="input-group">
              <label>Post Evaluation Subtitle Tracks</label>
              <div className="-subtitle-tracks">
                {evaluation.postTracks ? evaluation.postTracks.map((track, i) =>
                  <VideoTrackListItem
                    deleteTrack={deleteTrack}
                    handleTrackFormChange={handleTrackFormChange}
                    index={i}
                    key={i}
                    track={track}
                    formType='post'
                    />
                )
                :
                  null
                }
              </div>
              <button type="button" className="yt-btn x-small link success" onClick={() => addTrack('post')} style={{marginRight:20}}>+ Add track file</button>
            </div>
            <RichEditor
              change={handleFormChange}
              helpText="This appears on the final screen at the conclusion of the evaluation."
              isNewContent={formHelpers.isNewPostEvalContent}
              label="Post evaluation content"
              name="evaluation.postEvalContent"
              required={false}
              value={evaluation.postEvalContent && evaluation.postEvalContent.blocks && evaluation.postEvalContent.blocks.length > 0 ? evaluation.postEvalContent : convertToRaw(EditorState.createEmpty().getCurrentContent())}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > Save </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

EvaluationForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , evaluation: PropTypes.object.isRequired
  , formHelpers: PropTypes.object
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , contentModule: PropTypes.object.isRequired
}

EvaluationForm.defaultProps = {
  formHelpers: {}
  , formTitle: ''
}

export default EvaluationForm;



// WEBPACK FOOTER //
// modules/evaluation/components/EvaluationForm.js.jsx